const account_center = {
    not_enabled: 'Hesap merkezi etkin değil.',
    field_not_editable: 'Alan düzenlenemez.',
};
export default Object.freeze(account_center);
